/// <amd-module name="Build/Admin/Checks/Stores/SecurityStore" />
import { Store } from "VSS/Reflux/Store";

import { StoreStatus } from "Build/Admin/Common/Constants";

export interface ISecurityStoreState {
    hasManagePermission: boolean;
    status: StoreStatus;
}

export class SecurityStore extends Store {
    public state: ISecurityStoreState = {
        hasManagePermission: false,
        status: StoreStatus.None
    };

    constructor() {
        super("SecurityStoreChanged");
    }

    public updateStatus = (status: StoreStatus): void => {
        this.state = {
            ...this.state,
            status
        };

        this.emitChanged();
    }

    public updateManagePermission = (hasManagePermission: boolean): void => {
        this.state = {
            ...this.state,
            hasManagePermission
        };

        this.emitChanged();
    }
}
